import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import {
  PREMIUM_LEVEL_TO_QUALITY_BONUS,
  QUALITY_BONUS_CLASSES,
  QUALITY_BONUS_TRANSLATIONS,
} from '../../constants';
import { QualityBonus } from '../../model/quality-bonus-model';

@Component({
  selector: 'app-quality-bonus-status',
  templateUrl: './quality-bonus-status.component.html',
  styleUrls: ['./quality-bonus-status.component.scss'],
})
export class QualityBonusStatusComponent implements OnChanges {
  @Input() premiumPartnerLevel: number;
  @Input() inactive: boolean = false;

  qualityBonus: QualityBonus | null = null;

  ngOnChanges(changes: SimpleChanges) {
    if (changes['premiumPartnerLevel']) {
      if (!this.premiumPartnerLevel) {
        this.qualityBonus = null;

        return;
      }

      this.qualityBonus = this.mapPremiumLevelToQualityBonus(
        this.premiumPartnerLevel,
      );
    }
  }

  private mapPremiumLevelToQualityBonus(level: number): QualityBonus | null {
    return PREMIUM_LEVEL_TO_QUALITY_BONUS[level] ?? null;
  }

  getQualityBonusClass(qualityBonus: QualityBonus): string {
    return this.inactive ? 'primary' : QUALITY_BONUS_CLASSES[qualityBonus];
  }

  getQualityBonusTranslate(qualityBonus: QualityBonus): string {
    return QUALITY_BONUS_TRANSLATIONS[qualityBonus];
  }
}
